import React from "react";

const Spinner: React.FC = () => (
  <div className="flex justify-center items-center w-full">
    <span className="spinner" />
  </div>
);

export default Spinner;
